import React, { useEffect, useMemo, useState } from 'react';
import { Nav } from 'rsuite5';
import Image from '../Bicester/Image';
import usePrefix from '@/hooks/usePrefix';
import _ from 'lodash';
import history, { replace } from '@/utils/history';
import { useLocation } from 'react-router-dom';
import { MENU, MENU_MAP } from '@/constants/menu';
import { useReadyInfo } from '@/providers/ReadyProvider';
import { ROLE_TYPE } from '@/constants';

const BicesterNavbar: React.FC = () => {
  const { prefix, classname } = usePrefix('bicester-navbar');
  const { pathname } = useLocation();
  const { profile } = useReadyInfo();

  const [pathName, setPathName] = useState('');
  const [activeKey, setActiveKey] = useState('');

  const navTabs: {
    label: string;
    key: string;
    icon: string;
    activeIcon: string;
  }[] = useMemo(
    () =>
      [
        {
          label: MENU_MAP[MENU.CUSTOMER_ACCOUNT],
          key: MENU.CUSTOMER_ACCOUNT,
          icon: '/resources/images/layoutNavIcons/customer-account.svg',
          activeIcon: '/resources/images/layoutNavIcons/customer-account-active.svg',
        },
        {
          label: MENU_MAP[MENU.RECEIPT],
          key: MENU.RECEIPT,
          icon: '/resources/images/layoutNavIcons/receipt.svg',
          activeIcon: '/resources/images/layoutNavIcons/receipt-active.svg',
        },
        {
          label: MENU_MAP[MENU.SUBSCRIBE_SERVICE],
          key: MENU.SUBSCRIBE_SERVICE,
          icon: '/resources/images/layoutNavIcons/subscribe-service.svg',
          activeIcon: '/resources/images/layoutNavIcons/subscribe-service-active.svg',
        },
        {
          label: MENU_MAP[MENU.SITE_SERVICE],
          key: MENU.SITE_SERVICE,
          icon: '/resources/images/layoutNavIcons/site-service.svg',
          activeIcon: '/resources/images/layoutNavIcons/site-service-active.svg',
        },
        {
          label: MENU_MAP[MENU.EXCHANGE],
          key: MENU.EXCHANGE,
          icon: '/resources/images/layoutNavIcons/exchange.svg',
          activeIcon: '/resources/images/layoutNavIcons/exchange-active.svg',
        },
        {
          label: MENU_MAP[MENU.SPECIAL_SALE],
          key: MENU.SPECIAL_SALE,
          icon: '/resources/images/layoutNavIcons/special-sale.svg',
          activeIcon: '/resources/images/layoutNavIcons/special-sale-active.svg',
        },
        {
          label: MENU_MAP[MENU.IGURU],
          key: MENU.IGURU,
          icon: '/resources/images/layoutNavIcons/iguru.svg',
          activeIcon: '/resources/images/layoutNavIcons/iguru.svg',
        },
      ].filter((navTab) => {
        if (
          profile?.role === ROLE_TYPE.MANAGER ||
          profile?.role === ROLE_TYPE.GANGER ||
          profile?.role === ROLE_TYPE.AMBASSADOR
        ) {
          return true;
        } else if (profile?.role === ROLE_TYPE.PT) {
          // GE兼职：M1客户账户 M2小票管理 M6特卖入场
          return (
            navTab.key === MENU.CUSTOMER_ACCOUNT ||
            navTab.key === MENU.RECEIPT ||
            navTab.key === MENU.SPECIAL_SALE
          );
        } else if (profile?.role === ROLE_TYPE.OPS) {
          // OPS安保：M3预约服务
          return navTab.key === MENU.SUBSCRIBE_SERVICE;
        } else if (profile?.role === ROLE_TYPE.DRT) {
          // DRT导购大使：M1客户账户 M2小票管理 M3预约服务 M6特卖入场 M7 Iguru
          return (
            navTab.key === MENU.CUSTOMER_ACCOUNT ||
            navTab.key === MENU.RECEIPT ||
            navTab.key === MENU.SUBSCRIBE_SERVICE ||
            navTab.key === MENU.SPECIAL_SALE ||
            navTab.key === MENU.IGURU
          );
        }
        return true;
      }),
    [profile?.role]
  );

  const getDefaultNavTab = (navTab) => {
    return _.get(navTab, '[0].key', '');
  };

  const getCurrentNavTab = (pathname, navTabs) => {
    return navTabs.find((nav) => pathname.includes(`/${nav.key}`))?.key ?? '';
  };

  useEffect(() => {
    setActiveKey(getCurrentNavTab(pathname, navTabs) || getDefaultNavTab(navTabs));
  }, []);

  history.listen((location) => {
    const { pathname } = location;
    if (pathName !== pathname) {
      setPathName(pathname);
      setActiveKey(getCurrentNavTab(pathname, navTabs) || getDefaultNavTab(navTabs));
    }
  });

  return (
    <div className={classname}>
      <Nav
        className={prefix('nav')}
        onSelect={(nav) => {
          if (nav === MENU.IGURU) {
            window.open('https://wx.thebicestercollection.cn/member/index.php/Admin/Index/index.html');
          } else {
            replace(`/${nav}`);
          }
        }}
      >
        {navTabs.map((navTab, index) => {
          return (
            <Nav.Item
              className={prefix('nav-item')}
              active={activeKey === navTab.key}
              icon={
                <Image
                  src={activeKey === navTab.key ? navTab.activeIcon : navTab.icon}
                  draggable={false}
                />
              }
              key={navTab.key}
              eventKey={navTab.key}
            >
              <div className={prefix('nav-item-label')}>{navTab.label}</div>
            </Nav.Item>
          );
        })}
      </Nav>
    </div>
  );
};

export default BicesterNavbar;
